import type {
	AbschnittCCandidateGender,
	AbschnittCElectionCandidate,
	AbschnittCElectionListVoteResult,
	CandidateId
} from "@/lib/abschnittc/AbschnittCElection";
import type { EvaluatorContext } from "@/lib/abschnittc/impl/EvaluatorContext";
import type { PreliminaryListSpot } from "@/lib/abschnittc/AbschnittCElectionResult";

export interface AbschnittCRunoffCandidateReaderOptions {
	vote: AbschnittCElectionListVoteResult;
	candidates: AbschnittCElectionCandidate[];
	gender: AbschnittCCandidateGender;
	context: EvaluatorContext;
	preliminaryResults: PreliminaryListSpot[];
}

export class AbschnittCElectionListVoteResultRunoffCandidateReader {

	constructor(private options: AbschnittCRunoffCandidateReaderOptions) {
	}

	runoffCandidate(): CandidateId {

		const candidates = this.options.candidates;

		let minSpot = 1;
		const maxSpot = candidates.map((value) => value.minSpot)
			.reduce((a, b) => Math.max(a, b));

		const considered: string[] = [];

		while (minSpot <= maxSpot) {
			for (const entry of this.options.preliminaryResults) {
				const id = entry.candidate;
				const candidate = candidates
					.find((value) => value.id === id)!;

				if (candidate.minSpot <= minSpot)
					return id;
				else
					considered.push(id);
			}

			minSpot++;
		}

		throw new Error("No candidate found for runoff");
	}

}
